// /components/DietAssessment/components/AssessmentStep.js

import React, { useContext } from 'react';
import { Button, Box, useMediaQuery, useTheme } from '@mui/material';
import { AssessmentContext } from '../../../lib/contexts';

export const AssessmentSkipButton = (props) => {
  const theme = useTheme();
  const {
    actions: { handleNextStep },
  } = useContext(AssessmentContext);

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { boxSx } = props || {};

  // Use overrideLabel if provided, otherwise fall back to currentStepInfo
  const buttonLabel = props?.overrideLabel || props?.currentStepInfo?.buttonText || 'Skip';

  return (
    <Box
      id="assessment-skip-button"
      sx={{
        ...theme.globalClasses.assessmentButton,
        backgroundColor: isMobile ? 'background.paper' : 'transparent',
        ...boxSx,
        margin: '0',
        padding: '0',
      }}
    >
      <Button
        size="large"
        variant="text"
        onClick={() => handleNextStep()}
        sx={{
          maxWidth: '140px',
          width: '100%',
        }}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};
